import React from "react";
import imageOne from "../../resource/events/annualceremony/rainretreat/2.png";
import imageThree from "../../resource/events/annualceremony/rainretreat/1.png";

import imageFour from "../../resource/events/annualceremony/rainretreat/photos/1.jpeg";
import imageFive from "../../resource/events/annualceremony/rainretreat/photos/2.jpeg";
import imageSix from "../../resource/events/annualceremony/rainretreat/photos/3.jpeg";
import imageSeven from "../../resource/events/annualceremony/rainretreat/photos/4.jpeg";
import imageEight from "../../resource/events/annualceremony/rainretreat/photos/5.jpeg";

import imageNine from "../../resource/events/annualceremony/rainretreat/photos/7.jpeg";

import imageTen from "../../resource/events/annualceremony/rainretreat/photos/6.jpeg";
import imageEleven from "../../resource/events/annualceremony/rainretreat/photos/8.jpeg";





const RainRetreat = () => {
  return (
    <div className="danaPayment-page inside-pages">
      <div className="right-box">
        <img
          src={imageOne}
          alt="Right Top Image"
          className="right-image"
          width={300}
        />
      </div>
      <h1 className="font-second dark-gold mt-4 p-4">
        Information About Vassa (Rain Retreat)
      </h1>
      <p className="h4 p-4 mt-4">
        In the Theravada Buddhist tradition, Vassa, also known as the annual
        "rains retreat," is a three-month monastic practice that dates back to
        the time of the Buddha. This retreat typically spans from the July
        “Esala” Full Moon Poya day to the October “Vap” Full Moon Poya day.
      </p>

      <p className="h4 p-4 mt-4">
        For the benefit of the Sangha and the lay devotees who support them
        during the Vassa period, the following information is provided:
      </p>

      <p className="h4 p-4 mt-5">1. Invitation to Sangha</p>
      <p className="h4 p-4 mt-4">2. Spending the Vassa Period</p>
      <p className="h4 p-4 mt-4">3. Conclusion of the Vassa Period</p>
      <p className="h4 p-4 mt-4">4. Kathina Ceremony</p>

      <img
        src={imageFour}
        alt=""
        className="mt-6 p-4"
        style={{ width: "100%" }}
      />
      <h1 className="font-second dark-gold mt-5 p-4">Invitation to Sangha</h1>

      <p className="h4 p-4 mt-4">
        Before the Vassa season begins, it is customary in many temples to
        renovate, whitewash, or paint the monks' dwellings, repair walking
        paths, and make other necessary arrangements to ensure a comfortable
        living space for the Sangha.
      </p>
      <p className="h4 p-4 mt-5">
        On the Full Moon day of July, a devotee or a group of devotees
        undertakes the responsibility of sponsoring the Vassa retreat by
        inviting the Sangha to the monastery. This invitation is accompanied by
        offerings such as a rains bathing cloth (Vasi Salu) and other provisions
        that the monks may need for their daily living. The sponsoring devotees
        ensure that the monks observing the retreat are provided with the
        necessary requisites during the Vassa period
      </p>
      <p className="h4 p-4 mt-5">
        The Vassa invitation to the Sangha, requesting them to reside in the
        monastery for the rainy season, can also be performed within a week
        before the Full Moon Poya day if the Full Moon day itself is not
        feasible.
      </p>
      <p className="h4 p-4 mt-5">
        A typical invitation would include the following:
      </p>
      <p className="h4 p-4">
        “Dear Bhante, during the next three months of the rainy season, out of
        compassion for us, please observe the rains retreat in this monastery.
        We will support you with the four requisites.”
      </p>
      <p className="h4 p-4 mt-5">In Pali:</p>
      <p className="h4 p-4 ">
        “Imasmiṃ vihāre imaṃ te-māsaṃ vassaṃ upagamthun aradhanan karomi.” (×3)
      </p>
      <h1 className="font-second dark-gold mt-6 p-4">Spending the Vassa period</h1>


      <div class="container p-4 mt-5">
        <div class="images">
          <img
            src={imageFive}
            alt=""
            className="mt-6 p-4"
            style={{ width: "100%" }}
          />

          <img
            src={imageSix}
            alt=""
            className="mt-6 p-4"
            style={{ width: "100%" }}
          />

          <img
            src={imageSeven}
            alt=""
            className="mt-6 p-4"
            style={{ width: "100%" }}
          />
        </div>

        <div class="description">
          <p className="font-p  p-4 mt-4">
            During the Vassa period, the Sangha dedicates more time to intensive
            spiritual practice, focusing on meditation and study. Residing in
            one place with reduced travel and external activities allows the
            monks to immerse themselves in learning, discussing the Buddhist
            scriptures with other resident monks, and intensifying their
            meditation practice. This time also provides an opportunity to renew
            one's knowledge of the disciplinary rules (Vinaya), fostering
            harmony and unity among the resident monks.
          </p>
          <p className="font-p p-4 mt-4">
            While lay Buddhists are not required to observe the rains retreat,
            they can use this period to deepen their understanding and practice
            of Buddhist teachings. Lay devotees can earn merit by offering meals
            (Dana) and providing requisites to the Sangha, who, in turn, teach
            the Buddhist doctrine. This mutual exchange of support and teachings
            benefits both the monastic and lay communities.
          </p>
          <p className="font-p  p-4 mt-4">
            Additionally, lay disciples often take this time to intensify their
            religious practice by observing higher precepts, such as the Eight
            Precepts, and engaging in meditation, listening to Buddhist
            discourses, and chanting at the monastery. It is also common for lay
            devotees to ordain during the Vassa period. This time offers a
            unique opportunity for lay Buddhists to commit to abandoning certain
            habits, such as eating meat, smoking, or drinking alcohol, and to
            observe the Five Precepts more rigorously.
          </p>
        </div>
      </div>

      <h1 className="font-second dark-gold mt-6 p-4">Concluding the Vassa</h1>
      <p className="font-p  p-4 mt-4">At the end of the three-month rains retreat, the monks who spent the retreat together at the same residence gather to perform the Vassa Pavarana Ceremony, which marks the end of the retreat. This ceremony is exclusively for the Sangha, with no involvement from lay people.</p>
      <img
            src={imageEight}
            alt=""
            className="mt-5 p-4"
            style={{ width: "100%" }}
          />

<h1 className="font-second dark-gold mt-6 p-4">Kathina Ceremony</h1>
<div class="container p-4 mt-5">
        

        <div class="description">
          <p className="font-p  p-4 mt-4">
          The Kathina season begins after the Vassa period ends, on the full moon day of October, and continues until the next full moon day in November. During this time, monks and devotees arrange a suitable date to offer the Kathina robe to the group of monks who observed the rains retreat at the monastery. 
          </p>
          <p className="font-p p-4 mt-4">
          Offering the Kathina robe to the Sangha is considered especially meritorious following the intensive practice of Dhamma during the Vassa period. It is regarded as one of the eight offerings that bring great merit to the donors.
          </p>
          <p className="font-p  p-4 mt-6">
          These eight offerings are:
          </p>
          <p className="font-p p-4 mt-5">1. Offering of a Kathina robe.</p>
          <p className="font-p p-4 mt-4">2. Offering of the eight requisites of a monk (Ata Pirikara).</p>
          <p className="font-p p-4 mt-4">3. Offering of a place of residence to monks.</p>
          <p className="font-p p-4 mt-4">4. Offering alms to monks.</p>
          <p className="font-p p-4 mt-4">5. Gift of the Buddhist doctrine (Dhamma Dana).</p>
          <p className="font-p p-4 mt-4">6. Offering of lands and fields to the Buddhist dispensation.</p>
          <p className="font-p p-4 mt-4">7. Construction of images and statues of the Buddha.</p>
          <p className="font-p p-4 mt-4">8. Building and offering toilets for the use of monks.</p>

        </div>

        <div class="images">
          <img
            src={imageNine}
            alt=""
            className="mt-6 p-4"
            style={{ width: "100%" }}
          />

          <img
            src={imageTen}
            alt=""
            className="mt-6 p-4"
            style={{ width: "100%" }}
          />

          <img
            src={imageEleven}
            alt=""
            className="mt-6 p-4"
            style={{ width: "100%" }}
          />
        </div>
      </div>

<div className="p-4 mt-6 text-center">
    <div className="mt-6 calander-box align-item-center">
            <div className="c-details text-left">
                <h2 className='intro-text '>Contact Details : </h2>
                <p className="font-p mt-4">Monastery : 035608 0918 / 0459 729 738</p>
                <p className="font-p">Mr Gamini : 0422 069 359</p>
                <p className="font-p">WhatsApp : 0422 069 359</p>
                <p className="font-p">E-mail : info@bvp.org.au</p>
            </div>
           
        </div>
        </div>

        <div className="bottom-box mt-6">
        <img src={imageThree} alt="bottom-image"  width={600} />
    </div>
    </div>
  );
};

export default RainRetreat;
